// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M16.5 12l-7-7v14l7-7z"}}]};

const CaretRightSmallIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'caret-right-small',
    ref,
    icon: element,
  },
));

CaretRightSmallIcon.displayName = 'CaretRightSmallIcon';

export default CaretRightSmallIcon;
